import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { PspTagItem } from '@/models/psp-tag/psp-tag.model';

export default class GetPspTagRequest extends ApiResourceMethod<PspTagItem> {
  public perform(pspTagId: string): Promise<PspTagItem> {
    return this.performer.requestWithMapper(
      { url: pspTagId },
      (payload: BaseResponse<PspTagItem>): PspTagItem => payload.data,
    );
  }
}
